import React from 'react';
export function Hero() {
  const scrollToPurchase = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="pt-12 pb-12 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto text-center" data-id="element-24">
      <h1 className="text-3xl md:text-4xl lg:text-5xl font-sans font-black text-white leading-tight mb-6 tracking-tight" data-id="element-25">
        DEJÁ DE REDACTAR PUNTOS PERICIALES{' '}
        <span className="text-gold-500" data-id="element-26">"COMO PODÉS"</span>
      </h1>

      <div className="relative mx-auto max-w-2xl mb-6 cursor-pointer group" onClick={scrollToPurchase} data-id="element-27">
        <div className="absolute inset-0 bg-gold-500/10 blur-3xl rounded-full group-hover:bg-gold-500/20 transition-all duration-500" data-id="element-28"></div>
        <img src="https://cdn.magicpatterns.com/uploads/ghX7SNktu1E4iPpGYjQwTi/ChatGPT_Image_May_2__2026__11_08_12_AM-removebg-preview.png" alt="Redacción de Puntos Periciales PRO" className="relative z-10 w-4/5 mx-auto h-auto drop-shadow-2xl transform group-hover:scale-105 transition-transform duration-500" data-id="element-29" />
      </div>

      <p className="text-lg md:text-xl text-slate-200 mb-8 max-w-2xl mx-auto font-medium" data-id="element-30">
        Redacciones Periciales PRO es un sistema completo de redacción
        profesional. Formatos, estructuras y modelos listos para usar.
      </p>

      <a href="https://checkout.ebookpoint.shop/cart/59452963192913:1" className="inline-block w-full md:w-auto bg-[#dc2626] hover:bg-[#ef4444] text-white font-black text-xl md:text-2xl px-12 py-5 rounded-lg shadow-[0_0_20px_rgba(220,38,38,0.4)] hover:shadow-[0_0_30px_rgba(220,38,38,0.6)] transition-all transform hover:-translate-y-1 uppercase tracking-wide border-b-4 border-[#991b1b]" data-id="element-31">
        ¡QUIERO EL SISTEMA AHORA!
      </a>
    </section>;
}